import React from 'react';
import { renderToString } from 'react-dom/server';

import { StickyNoteIcon } from '../../../icon/regular';
import {
  InstructionActionTooltip,
  InstructionCSSClasses,
  InstructionEvent,
} from '../types';
import { addInstructionEvent, emitInstructionEvent } from '../utils';
import BlockInstruction from '../base-instruction/BlockInstruction';

class NoteInstructionBlock extends BlockInstruction {
  static initiable = false;

  get isInit() {
    return NoteInstructionBlock.initiable;
  }

  set isInit(value: boolean) {
    NoteInstructionBlock.initiable = value;
  }

  get instructionClasses() {
    return {
      wrapper: InstructionCSSClasses.NOTE_INSTRUCTION_BLOCK,
      action: InstructionCSSClasses.NOTE_INSTRUCTION_BLOCK_ACTION,
      content: InstructionCSSClasses.NOTE_INSTRUCTION_BLOCK_CONTENT,
    };
  }

  static get toolbox() {
    return {
      icon: renderToString(<StickyNoteIcon style={{ height: 20 }} />),
      title: 'Editor note',
    };
  }

  get tooltip() {
    return InstructionActionTooltip.note;
  }

  static get sanitize() {
    return {
      ...BlockInstruction.sanitize,
      a: true,
    };
  }

  async openModal(instructionId: string) {
    emitInstructionEvent(
      this.api.events,
      InstructionEvent.OPEN_NOTE_INSTRUCTION_MODAL,
      {
        instructionId,
        isInline: false,
      },
    );
  }

  initEvents(): void {
    this.saveInstruction = this.saveInstruction.bind(this);
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SAVE_NOTE_INSTRUCTION_BLOCK,
      this.saveInstruction,
    );
  }

  removeEvents(): void {
    this.api.events.off(
      InstructionEvent.SAVE_NOTE_INSTRUCTION_BLOCK,
      this.saveInstruction,
    );
  }
}

export default NoteInstructionBlock;
